//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FixedBanner from "@Shared/components/general/fixed-banner.vue";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import { useAccountStoreGetters, useAccountStoreActions } from "@Client/@Modules/main/store/account/account-helpers";
import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "EmailVerificationBanner",
  components: {
    FixedBanner
  },
  props: {
    positionFixed: {
      type: Boolean,
      default: true
    },
    sideRight: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const loading = ref(false);
    const {
      locale
    } = useI18n();
    const {
      RESEND_CONFIRMATION_EMAIL
    } = useAccountStoreActions([AccountActions.RESEND_CONFIRMATION_EMAIL]);
    const {
      EMAIL_VERIFIED,
      CURRENT_USER_DETAILS,
      ACCOUNT_SUBDOMAIN,
      EMAIL_VERIFIED_ALREADY_SENT
    } = useAccountStoreGetters([AccountGetters.EMAIL_VERIFIED, AccountGetters.CURRENT_USER_DETAILS, AccountGetters.ACCOUNT_SUBDOMAIN, AccountGetters.EMAIL_VERIFIED_ALREADY_SENT]);
    const show = computed(() => {
      return !EMAIL_VERIFIED.value;
    });
    onMounted(() => {
      emit("update:show", show.value);
    });
    const handleValidateEmail = async ({
      isResent
    }) => {
      loading.value = true;
      await RESEND_CONFIRMATION_EMAIL({
        email: CURRENT_USER_DETAILS.value.email,
        currentSubdomain: ACCOUNT_SUBDOMAIN.value,
        locale: locale.value,
        isResent
      });
      loading.value = false;
    };
    const emailSent = computed(() => {
      return EMAIL_VERIFIED_ALREADY_SENT.value;
    });
    const bannerType = computed(() => {
      return emailSent.value ? "notice" : "error";
    });
    return {
      show,
      handleValidateEmail,
      emailSent,
      bannerType,
      loading
    };
  }
});